export default "__VITE_ASSET__902a206c__"